import { HighlightOff } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import CheckBrokenIcon from 'components/Icons/CheckBrokenIcon';
import ClockCheck from 'components/Icons/ClockCheck';
import React from 'react';

const STATUS = {
  paid: {
    text: 'Paid',
    Icon: ClockCheck,
    color: 'rgba(0, 128, 58, 1)',
  },
  cancelled: {
    text: 'Cancelled',
    Icon: HighlightOff,
    color: 'rgba(255, 103, 93, 1)',
  },
  wait_for_paying: {
    text: 'Pending',
    Icon: CheckBrokenIcon,
    color: 'rgba(234, 163, 0, 1)',
  },
};

const StatusInvoice = ({ status, iconSize = 16 }) => {
  const { text, Icon, color } = STATUS[status] || STATUS['paid'];
  return (
    <Box display={'flex'} alignItems={'center'} gap={1}>
      <Icon
        color={color}
        width={iconSize}
        height={iconSize}
        size={iconSize}
        sx={{
          fontSize: iconSize,
          color: color,
        }}
      />
      <Typography color={color} fontWeight={500} fontSize={12}>
        {text}
      </Typography>
    </Box>
  );
};

export default StatusInvoice;
